import {ThreeTsl as TSL} from "#material/three/exports"
import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {TangentSockets} from "#material/nodes/input/tangent/definition"
import {tangentDefinition} from "#material/nodes/input/tangent/definition"
import {registerMaterialGraphNode} from "#material/register"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {cyclesAxis, cyclesDirectionType} from "#material/nodes/input/tangent/helpers"
import type {CyclesReturns} from "#material/sockets/cycles"
import type {ThreeReturns} from "#material/sockets/three"
import type {TangentNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class Tangent extends MaterialNode<TangentSockets> {
    public override get definition() {
        return tangentDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<TangentSockets>> => {
        //TODO: use THREE.BufferGeometryUtils.computeTangents when loading mesh?
        return {tangent: TSL.attribute("tangent", "vec3")}
    }

    override toCycles = async (_evaluator: CyclesEvaluator): Promise<CyclesReturns<TangentSockets>> => {
        const tangentNode: TangentNode = {
            type: "tangent",
            inputs: {},
            parameters: {
                axis: cyclesAxis(this.parameters.settings.axis),
                direction_type: cyclesDirectionType(this.parameters.settings.directionType),
                attribute: undefined,
            },
            resources: {},
        }

        return {tangent: [tangentNode, "tangent"]}
    }
}
